import type { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const ADMIN_GROUP_ID =
  import.meta.env.VITE_ENTRA_ADMIN_GROUP_ID ??
  "886f0535-42c5-4c3c-9b2d-b5b8df983de1";

export const ADMIN_USERS: string[] = import.meta.env.VITE_ADMIN_USERS
  ? (import.meta.env.VITE_ADMIN_USERS as string)
      .split(",")
      .map((u) => u.trim().toLowerCase())
  : [];

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile"],
};

export const apiScopes = {
  scopes: [`${import.meta.env.VITE_ENTRA_CLIENT_ID}/.default`],
};
